import { httpClient } from '@/core/api/client/httpClient'

export interface ProfileData {
  contactId: string | null
  firstName: string | null
  lastName: string | null
  email: string | null
  governmentId: string | null
  mobilePhone: string | null
  mobilePhoneE164: string | null
  birthDate: string | null
  country: { id: string | null; name: string | null } | null
  accessStatus: number | null
  isPortalEnabled: boolean | null
}

interface MeResponse { success: boolean; data: { profile: ProfileData | null } }
interface ActionResponse { success: boolean }

export interface ChangePasswordRequest {
  currentPassword: string
  newPassword: string
  confirmPassword: string
}

export interface SuspendAccountRequest {
  reason?: string
}

export const profileService = {
  async get(): Promise<ProfileData> {
    const response = await httpClient.get<MeResponse>('/api/auth/me')
    if (!response.data?.profile) throw new Error('No se encontró el perfil.')
    return response.data.profile
  },
  async changePassword(request: ChangePasswordRequest, lang = 'es'): Promise<void> {
    const response = await httpClient.post<ActionResponse>(`/api/auth/me/password?lang=${lang}`, request)
    if (!response.success) throw new Error('No se pudo cambiar la contraseña.')
  },
  async suspendAccount(request: SuspendAccountRequest, lang = 'es'): Promise<void> {
    const response = await httpClient.post<ActionResponse>(`/api/auth/me/suspend?lang=${lang}`, request)
    if (!response.success) throw new Error('No se pudo suspender la cuenta.')
  },
}
